const blobFile = (blobArray: Array<number>) => {
 const uint8Array = new Uint8Array(blobArray);

 const blob = new Blob([uint8Array]); // , { type: 'image/jpeg' }

 const urlCreator = window.URL || window.webkitURL;

 const url = urlCreator.createObjectURL(blob);

 return url;
};

export default blobFile;
